import { ITaskMeetingContact } from './contact.model';
import { IAvailabilityWindowSchema } from './meeting-types.model';

/** TODO: This is a dumb copy from BE, anything typed with any has its own interface */
/** We should really unify the BE and FE types instead of making unsynced copies in both repos */

export interface IWizardTaskMeeting extends ITaskMeeting {
    meetingTime?: { start: string; end: string };
}

export interface ITaskMeeting {
    type?: string;
    locations: any[];
    subject: string;
    lastNotificationDate: Date;
    numberOfNotifications: number;
    numberOfNotificationsToCreator?: number;
    meetingLength: number;
    travelTime: number;
    directCreate?: boolean;
    eventXref?: string;
    calendarId?: string;
    dateStart: Date;
    dateEnd: Date;
    dateCancelled?: Date;
    calendarDateStart?: Date;
    description?: string;
    contacts: ITaskMeetingContact[];
    video?: any;
    ats?: any;
    crm?: any;
    isOndemand?: boolean;
    videoProvider?: { id: string; type: string };
    availabilityType?: any;
    availabilityUserIds?: string[];
    status: any;
    dateStatusUpdated: Date;
    schedulingLink?: string;
    availabilityWindows?: IAvailabilityWindowSchema;
    maxAttendees?: number;
}
